import React, { useEffect, useRef, useState } from 'react';
import { Alert, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import { getIntakeSummary } from '../../services/api';
import { ownerScope, transactionsChanged } from '../../utils/intake';

export default function IntakeReminder() {
  const [summary, setSummary] = useState(null);
  const lastPosted = useRef(null);
  useEffect(() => {
    let alive = true, running = false;
    const scope = ownerScope();
    const refresh = async () => {
      if (running || !alive || !localStorage.getItem('access_token') || document.hidden) return;
      running = true;
      try {
        const { data } = await getIntakeSummary();
        if (!alive || ownerScope() !== scope) return;
        const postedAt = data.last_posted_at || 'none';
        if (lastPosted.current && lastPosted.current !== postedAt) transactionsChanged();
        lastPosted.current = postedAt;
        setSummary(data);
      } catch { /* Do not disrupt ordinary pages if this optional queue is unavailable. */ }
      finally { running = false; }
    };
    refresh();
    const timer = setInterval(refresh, 15000);
    window.addEventListener('accounting:intake-changed', refresh);
    window.addEventListener('visibilitychange', refresh);
    return () => { alive = false; clearInterval(timer); window.removeEventListener('accounting:intake-changed', refresh); window.removeEventListener('visibilitychange', refresh); };
  }, []);
  if (!summary?.attention_count) return null;
  return <Alert severity={summary.needs_review || summary.older_pending ? 'warning' : 'info'} sx={{ m: 1 }}
    action={<Button color="inherit" component={Link} to="/daily-tally">Open tally</Button>}>
    {summary.tally_pending} unpaid purchases{summary.older_pending ? ` (${summary.older_pending} from earlier days)` : ''}
    {summary.processing ? ` · ${summary.processing} receipts processing` : ''}
    {summary.needs_review ? ` · ${summary.needs_review} need review` : ''}
  </Alert>;
}
